import React from 'react';
import { z } from 'zod';
import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { CurrencyInputField, RadioGroupField } from 'components/form';
import { FinanceStructureSchema } from '../model';
import { existingProgramTypeOptions } from '../constants';
import { determineMaxApprovalAmountNotification } from '../../../lib';

interface Props {
  financeAmount: number;
  maxApprovalAmount: number;
}

export const InitializeWorkflow = ({ financeAmount, maxApprovalAmount }: Props) => {
  const { control } = useFormContext<z.infer<typeof FinanceStructureSchema>>();

  return (
    <>
      <Box className="row">
        <RadioGroupField
          row
          control={control}
          className="flexed-radio"
          label="Use Saved Program?"
          options={existingProgramTypeOptions}
          name="financeQuote.createProposalWithExistingProgram"
        />
      </Box>

      <CurrencyInputField
        control={control}
        label="Max Approval Amount"
        name="financeQuote.maxApprovalAmount"
        notify={determineMaxApprovalAmountNotification(financeAmount, maxApprovalAmount)}
        textFieldProps={{
          placeholder: 'Enter amount...',
        }}
      />
    </>
  );
};
